import React, {useEffect, useRef, useState} from 'react'
import * as THREE from 'three';
import {IAttributes} from "../../reducers/project";
import {PerspectiveCamera, Scene, WebGLRenderer} from "three";
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";
import {OBJLoader} from "three/examples/jsm/loaders/OBJLoader";
import {useSelector} from "react-redux";
import {getSelectedAttributes} from "../../reducers/project/selectors";
import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";
import {RoomEnvironment} from "three/examples/jsm/environments/RoomEnvironment";




function Renderer({     preview,
                      width,
                      wrapperStyle,
                      small,
                      offsetHeight = 72}: IRenderer) {
    const contenerRef = React.useRef((null as unknown) as HTMLDivElement);
    const scene = useRef<Scene>()
    const camera = useRef<PerspectiveCamera>()
    const renderer = useRef<WebGLRenderer>()
    const controls = useRef<OrbitControls>()
    const loadergltf = useRef<GLTFLoader>(new GLTFLoader())
    const [store, setStore] = useState<IAttributes[]>([])
    const selectedStore = useSelector(getSelectedAttributes);
    const [objectList, setObjecList] = useState<any>([])


    useEffect(() => {
        if(contenerRef.current) {
            const {width, height} = contenerRef.current.getBoundingClientRect()

            const s = new THREE.Scene();
            const c = new THREE.PerspectiveCamera( 75, width / height, 0.1, 1000 );

            scene.current = s
            camera.current = c

            const r = new THREE.WebGLRenderer();

            renderer.current = r
            const pmremGenerator = new THREE.PMREMGenerator( r );
            s.background = new THREE.Color( 0xbfe3dd );
            s.environment = pmremGenerator.fromScene( new RoomEnvironment(), 0.04 ).texture;

            // const hemiLight = new THREE.HemisphereLight( 0xffffff, 0x444444 );
            // hemiLight.position.set( 0, 200, 100 );
            // s.add( hemiLight );

            const o = new OrbitControls( c, r.domElement );

            controls.current = o
            o.update()

            r.setSize( width, height );
            contenerRef.current.innerHTML = '';
            contenerRef.current.appendChild( r.domElement );
        }
    }, [contenerRef.current])

    useEffect(() => {
        if(renderer.current && scene.current && camera.current) {


            camera.current?.position.fromArray([0, 120.50944195694444, 100.97633415958694]);
             // @ts-ignore
            (controls.current as any).target = new THREE.Vector3(0, 30, 0);
            controls.current?.update()

            const animate = () => {
                requestAnimationFrame(animate);
                controls.current?.update()
                renderer?.current?.render(scene?.current as any, camera?.current as any);
            }
            animate();
        }


    }, [scene.current, camera.current, renderer.current, controls.current])

    useEffect(() => {


        const green = new THREE.MeshBasicMaterial({ color: 0x00ff00, wireframe: false })
        const blue = new THREE.MeshBasicMaterial({ color: 0x0000ff, wireframe: false })
        const red = new THREE.MeshBasicMaterial({ color: 0xff0000, wireframe: false })

        //difference between store and selectedStore
        const difference = store.filter(x => !selectedStore.includes(x))

        difference.forEach((item) => {
            const objects = objectList.filter((obj: any) => obj.id === item.id)
            setObjecList(objectList.filter((obj: any) => obj.id !== item.id))
            objects.forEach((obj: any) => {
                scene.current?.remove(obj.object)
            })

        })

        const colors = selectedStore.filter((item) => item.category.includes('kolor'))

        colors.forEach((item) => {
           const ramy = objectList.filter((obj: any) => obj.category === 'rama')
           const kola = objectList.filter((obj: any) => obj.category === 'kola')
           const kierownice = objectList.filter((obj: any) => obj.category === 'kierownica')


            console.log(ramy, kola, kierownice, item)

            if(item.category.includes('rama')) {
                ramy.forEach((obj: any) => {
                    obj.object.traverse((child: any) => {
                        if (child instanceof THREE.Mesh) {


                            if(item.name === 'Zielony') {
                                child.material = green
                            } else if(item.name === 'Czerwony') {
                                child.material = red
                            } else if(item.name === 'Niebieski') {
                                child.material = blue
                            }

                        }
                    })
                })
            }

            if(item.category.includes('kola')) {
                kola.forEach((obj: any) => {
                    obj.object.traverse((child: any) => {
                        if (child instanceof THREE.Mesh) {
                            if(item.name === 'Zielony') {
                                child.material = green
                            } else if(item.name === 'Czerwony') {
                                child.material = red
                            } else if(item.name === 'Niebieski') {
                                child.material = blue
                            }
                        }
                    })
                })
            }

            if(item.category.includes('kierownica')) {
                kierownice.forEach((obj: any) => {
                    obj.object.traverse((child: any) => {
                        if (child instanceof THREE.Mesh) {
                            if(item.name === 'Zielony') {
                                child.material = green
                            } else if(item.name === 'Czerwony') {
                                child.material = red
                            } else if(item.name === 'Niebieski') {
                                child.material = blue
                            }
                        }
                    })
                })
            }



        })


        const objectToRender = selectedStore.filter(x => !store.includes(x)).filter((item) => !item.category.includes('kolor'))

        objectToRender.map((item) => {
            loadergltf.current.load(item.vimg, (gltf) => {

                gltf.scene.traverse((o) => {
                    if (o instanceof THREE.Mesh) {

                        if(item.category === 'rama') {
                            const color = selectedStore.find((x) => x.category === 'rama_kolor')
                            if(color) {
                                if(color.name === 'Zielony') {
                                    o.material = green
                                } else if(color.name === 'Czerwony') {
                                    o.material = red
                                } else if(color.name === 'Niebieski') {
                                    o.material = blue
                                }
                            }
                        }
                        if(item.category === 'kierownica') {
                            const color = selectedStore.find((x) => x.category === 'kierownica_kolor')
                            if(color) {
                                if(color.name === 'Zielony') {
                                    o.material = green
                                } else if(color.name === 'Czerwony') {
                                    o.material = red
                                } else if(color.name === 'Niebieski') {
                                    o.material = blue
                                }
                            }
                        }
                        if(item.category === 'kola') {
                            const color = selectedStore.find((x) => x.category === 'kola_kolor')
                            if(color) {
                                if(color.name === 'Zielony') {
                                    o.material = green
                                } else if(color.name === 'Czerwony') {
                                    o.material = red
                                } else if(color.name === 'Niebieski') {
                                    o.material = blue
                                }
                            }
                        }
                    }
                });

                setObjecList([...objectList, {
                    id: item.id,
                    category: item.category,
                    object: gltf.scene
                }])

                scene.current?.add(gltf.scene)

            })
        })

        setStore(selectedStore)
    }, [selectedStore])

 return (
     <div
         ref={contenerRef}
         style={{
          height: !!preview
              ? `calc(100% - ${offsetHeight}px)`
              : "calc(100% - 144px)",
          width: width || "100%",
          overflow: "hidden",
          ...wrapperStyle,
         }}
     >
   
  </div>
 );
};

export interface IRenderer {
    preview?: IAttributes[];
    width?: string;
    wrapperStyle?: React.CSSProperties;
    small?: boolean;
    offsetHeight?: number;
}

export default Renderer